import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import React, {useState} from 'react';
import NotFound from './pages/NotFound';
import Root from './pages/Root';
import Main from './pages/Main';
import LogIn from './pages/LogIn';
import MyPage from './pages/MyPage';
import Join from './pages/Join';
import Category from './pages/Category';
import Pick from './pages/Pick';
import Cart from './pages/Cart';
import JoinTerms from './pages/JoinTerms';
import JoinSuccess from './pages/JoinSuccess';
import TermsOfUse from './pages/TermsOfUse';
import TermsPrivat from './pages/TermsPrivat';
import Language from './pages/Language';
import DelivManagement from './pages/DelivManagement';
import DelivAdd from './pages/DelivAdd';
import InquiryOoo from './pages/InquiryOoo';
import InquiryOooWrite from './pages/InquiryOooWrite';
import InquiryProduct from './pages/InquiryProduct';
import InquiryBulk from './pages/InquiryBulk';
import InquiryBulkWrite from './pages/InquiryBulkWrite';
import OrderHistory from './pages/OrderHistory';
import OrderHistoryDetail from './pages/OrderHistoryDetail';
import Categories from './pages/Categories';
import Categories2 from './pages/Categories2';
import ProductDetail from './pages/ProductDetail';
import ProductReview from './pages/ProductReview';
import ProductQnA from './pages/ProductQnA';
import ProductQnAWrite from './pages/ProductQnAWrite';
import ProductBuyInfo from './pages/ProductBuyInfo';
import CouponAvail from './pages/CouponAvail';
import CouponUsed from './pages/CouponUsed';
import Order from './pages/Order';
import Search from './pages/Search';
import OrderCoupon from './pages/OrderCoupon';
import OrderAddCard from './pages/OrderAddCard';
import OrderModifyOrderer from './pages/OrderModifyOrderer';
import DelivStatus from './pages/DelivStatus';
import OrderPayment from './pages/OrderPayment';
import OrderCancel from './pages/OrderCancel';
import OrderFin from './pages/OrderFin';
import ReturnRequest from './pages/ReturnRequest';
import Review from './pages/Review';
import ReviewFin from './pages/ReviewFin';
import ReviewWrite from './pages/ReviewWrite';
import ConfirmGoodsReceived from './pages/ConfirmGoodsReceived';
import OftenQnA from './pages/OftenQnA';
import NoticeList from './pages/NoticeList';
import NoticeView from './pages/NoticeView';
import Event from './pages/Event';
import CheckMemberInfo from './pages/CheckMemberInfo';
import ChangeMemberInfo from './pages/ChangeMemberInfo';
import DeleteAccount from './pages/DeleteAccount';
import EventProduct from './pages/EventProduct';
import SearchList from './pages/SearchList';
import MilegeHistory from './pages/MilegeHistory';


import TestPage from './pages/Test';
import './App.css';
import { RecoilRoot } from "recoil";
import { useTranslation } from 'react-i18next';
import styled, { ThemeProvider } from 'styled-components';
import GlobalStyle from './theme/global';
import { LanguageTheme } from "./services/common";
import i18n from "i18next";

const PrivateRoute = ({  element }) => {  
  const userData = localStorage.getItem("user");
  const location = useLocation();
  if (userData === null) {
  
    return <Navigate to={'/LogIn'} state={{ from: location }} replace />;
  }

  return element;
};

const App = () => {
  const { t } = useTranslation();
  const [themeMode, setThemeMode] = useState(LanguageTheme());
  const navigate = useNavigate(); 

  const checkLanguageClose = () => {
    const expireDay = localStorage.getItem("languageNoShow");
    let today = new Date();
  
    if(today.getTime() > expireDay) { 
      return false;
    } else {
      return true;
    }
  }
  const location = useLocation();
  const pathName = location.pathname.split('/');
  
  
  const [languageMode, setLanguageMode] = useState(checkLanguageClose() === false && localStorage.getItem("language")===null);

  if(pathName.length === 3){
    if(pathName[1] === 'Language' && (pathName[2] ==='ko' || pathName[2] ==='en' || pathName[2] ==='th' || pathName[2] ==='vn')){
      i18n.changeLanguage(pathName[2]);
      localStorage.setItem("language", pathName[2]);
      window.location.href ="/";
      return (<></>)
    }
  }

  


  const changeTheme = (mode) =>{
    setThemeMode(mode);
  };

  return (
    <>
    {languageMode ? (
      <Language changeTheme={changeTheme}  mode={true}/>
    ) :(
    <ThemeProvider theme={themeMode}>
    <GlobalStyle />
    <RecoilRoot> 
      <Routes>
        <Route path="/" element={<Root />} >
          <Route path='/' element={<Main />} /> 
          <Route path='/Category' element={<Category />} /> 
          <Route path='/Categories/:id' element={<Categories />} /> 
          <Route path='/ProductDetail/:id' element={<ProductDetail />} /> 
          <Route path='/Categories2' element={<Categories2 />} /> 
          <Route path='/ProductDetail' element={<ProductDetail />} /> 
          <Route path='/ProductReview/:id' element={<ProductReview />} /> 
          <Route path='/ProductQnA/:id' element={<ProductQnA />} /> 
          <Route path='/ProductQnAWrite/:id' element={<PrivateRoute element={<ProductQnAWrite />}/>} /> 
          <Route path='/ProductBuyInfo/:id' element={<ProductBuyInfo />} /> 
          <Route path='/Language' element={<Language changeTheme={changeTheme} />} />                
          <Route path='/Pick' element={<PrivateRoute element={<Pick />}/>} /> 
          <Route path='/Search' element={<Search />} /> 
          <Route path='/Search/:id' element={<Search />} /> 
          <Route path='/SearchList/:id' element={<SearchList />} /> 
          <Route path='/Cart' element={<Cart />} /> 
          <Route path='/Order' element={<PrivateRoute element={<Order />}/>} /> 
          <Route path='/OrderFin' element={<PrivateRoute element={<OrderFin />}/>} /> 
          <Route path='/OrderCoupon' element={<PrivateRoute element={<OrderCoupon />}/>} /> 
          <Route path='/OrderAddCard' element={<PrivateRoute element={<OrderAddCard />}/>} /> 
          <Route path='/OrderModifyOrderer' element={<PrivateRoute element={<OrderModifyOrderer />}/>} /> 
          <Route path='/OrderPayment' element={<PrivateRoute element={<OrderPayment />}/>} /> 
          <Route path='/OrderCancel/:id' element={<PrivateRoute element={<OrderCancel />}/>} /> 
          <Route path='/ReturnRequest/:id' element={<PrivateRoute element={<ReturnRequest />}/>} /> 
          <Route path='/EventProduct/:id' element={<EventProduct/>}/>


          <Route path='/LogIn' element={<LogIn />} /> 
          <Route path='/MyPage' element={<PrivateRoute element={<MyPage />}/>} /> 
          <Route path='/MilegeHistory' element={<PrivateRoute element={<MilegeHistory />}/>} /> 
          <Route path='/OrderHistory' element={<PrivateRoute element={<OrderHistory/>}/>}/>
          <Route path='/OrderHistoryDetail/:id' element={<PrivateRoute element={<OrderHistoryDetail/>}/>}/>
          <Route path='/CouponAvail' element={<PrivateRoute element={<CouponAvail/>}/>}/>
          <Route path='/CouponUsed' element={<PrivateRoute element={<CouponUsed/>}/>}/>
          <Route path='/ConfirmGoodsReceived/:id' element={<PrivateRoute element={<ConfirmGoodsReceived/>}/>}/>
          <Route path='/DelivStatus/:id' element={<PrivateRoute element={<DelivStatus/>}/>}/>
          <Route path='/CheckMemberInfo' element={<PrivateRoute element={<CheckMemberInfo />}/>} /> 
          <Route path='/ChangeMemberInfo' element={<PrivateRoute element={<ChangeMemberInfo />}/>} />
          <Route path='/DeleteAccount' element={<PrivateRoute element={<DeleteAccount />}/>} />

          <Route path='/Review' element={<PrivateRoute element={<Review/>}/>}/>
          <Route path='/ReviewFin' element={<PrivateRoute element={<ReviewFin/>}/>}/>
          <Route path='/ReviewWrite/:id' element={<PrivateRoute element={<ReviewWrite/>}/>}/>

          <Route path='/Join' element={<Join />} /> 
          <Route path='/JoinTerms' element={<JoinTerms />} /> 
          <Route path='/JoinSuccess' element={<JoinSuccess />} /> 
          <Route path='/DelivManagement' element={<PrivateRoute element={<DelivManagement />}/>}/>
          <Route path='/DelivAdd' element={<DelivAdd />}/>
          <Route path='/OftenQnA' element={<OftenQnA />}/>
          <Route path='/Notice' element={<NoticeList />}/>
          <Route path='/NoticeView' element={<NoticeView />}/>
          <Route path='/Event' element={<Event />}/>
          
          <Route path='/Inquiry' element={<PrivateRoute element={<InquiryOoo/>}/>}/>
          <Route path='/InquiryProduct' element={<PrivateRoute element={<InquiryProduct />}/>}/>
          <Route path='/InquiryBulk' element={<PrivateRoute element={<InquiryBulk />}/>}/>
          <Route path='/InquiryWrite' element={<PrivateRoute element={<InquiryOooWrite />}/>}/>
          <Route path='/InquiryBulkWrite' element={<PrivateRoute element={<InquiryBulkWrite />}/>}/>

          

          <Route path='/TermsOfUse' element={<TermsOfUse />} /> 
          <Route path='/TermsPrivat' element={<TermsPrivat />} /> 

          <Route path='/TestPage' element={<TestPage />} /> 
        </Route>
        <Route path="*" element={<NotFound />} /> 
      </Routes>
   
    </RecoilRoot>
    </ThemeProvider>
    )}
    </>
  );
}

export default App;